export default "__VITE_ASSET__CIGghqDH__"